import { API_ROUTES } from '../../../../../shared/app-configs/sc-app-config';
import { TCAppConfig } from '../../../../../shared/app-configs/tc-app-configs';
import { FacilityInformation, FacilityProcessDetails, FacilityState } from '../../../sc-models/facility-product-dto';

/**
 * Fetch facility details using the given API caller.
 *
 * @param executeGet - The API call function from your custom hook.
 * @param scId - The scId query parameter.
 * @param facilityId - The facility identifier.
 * @returns A promise that resolves with the facility details.
 * @throws An error if the fetch fails.
 */
export async function fetchFacilityDetails(
  executeGet: (url: string, params: Record<string, any>) => Promise<any>,
  scId: string,
  facilityId: string
): Promise<any> {
  if (!facilityId) return null;
  try {
    const response = await executeGet(API_ROUTES.GET_FACILITY_DETAILS_NEW
        , {
      scId,
      facilityId,
    });
    return response;
  } catch (err) {
    console.error('Error fetching facility details:', err);
    throw new Error('Failed to load facility details.');
  }
}
export const mapFacilityDetails = (data: {
    facilityDetails: any[];
  }): any[] => {
    if (!Array.isArray(data.facilityDetails)) {
      throw new Error("Invalid facility details: Expected an array");
    }
  
    return data.facilityDetails.map((facility, index) => {
      // Required field validation
      if (!facility.facilityNo || !facility.facilityName) {
        throw new Error(`Missing required fields in facility at index ${index}`);
      }
  
      const facilityInfo = {
        isMainSite: facility.isMainSite || "N",
        facilityNo: facility.facilityNo || "",
        facilityType: facility.facilityType || "",
        facilityOARId: facility.facilityOarId || "",
        lastAuditDate: facility.facilityLastAuditDate || "",
        farmCapacity: facility.facilityFarmCapacity || [],
        farmNoAnimals: facility.facilityFarmNoAnimals || [],
        iId: facility.facilityTeId || "",
        facilityStandard: facility.facilityStandard || [],
        name: facility.facilityName || "",
        address1: facility.facilityAddress1 || "",
        address2: facility.facilityAddress2 || "",
        address3: facility.facilityAddress3 || "",
        postcode: facility.facilityPostcode || "",
        town: facility.facilityTown || "",
        countryArea: facility.facilityCountryOrArea || "",
        stateProvince: facility.facilityStateOrProvince || "",
        subcontractorLicenseNo: facility.facilitySubcontractorLicenseNo || "",
        certificationBody: facility.facilityCbOfIndependentlyCertifiedSubcontractor || "",
        expiryDate: facility.facilityExpiryDateOfIndependentlyCertifiedSubcontractor || "",
      };
  
      const facilityProcessDetails = (facility.facilityProcessDetails || []).map(
        (process: any) => ({
          FacilityProccessCategoryCode: process.facilityProcessCategoryCode || "",
          FacilityProcessUserSpecificTerm: process.facilityProcessCategoryUserSpecificTerm || "",
        })
      );
  
      return {
        facilityInfo,
        facilityProcessDetails,
      };
    });
  };
  
 export  function convertFacilityData(rawData: any): FacilityState {
    const facility = rawData.facilityDetails?.[0] ?? {};
    const facilityInfo: FacilityInformation = {
      isMainSite: facility.isMainSite || '',
      facilityNo: facility.facilityNo || '',
      facilityType: facility.facilityType || '',
      facilityOARId: facility.facilityOarId || '',
      lastAuditDate: facility.facilityLastAuditDate || '',
      farmCapacity: facility.facilityFarmCapacity || [],
      farmNoAnimals: facility.facilityFarmNoAnimals || [],
      iId: facility.facilityTeId || '',
      facilityStandard: facility.facilityStandard || [],
      name: facility.facilityName || '',
      address1: facility.facilityAddress1 || '',
      address2: facility.facilityAddress2 || '',
      address3: facility.facilityAddress3 || '',
      postcode: facility.facilityPostcode || '',
      town: facility.facilityTown || '',
      countryArea: facility.facilityCountryOrArea || '',
      stateProvince: facility.facilityStateOrProvince || '',
      subcontractorLicenseNo: facility.facilitySubcontractorLicenseNo || '',
      certificationBody: facility.facilityCbOfIndependentlyCertifiedSubcontractor || '',
      expiryDate: facility.facilityExpiryDateOfIndependentlyCertifiedSubcontractor || '',
    };
  
    const facilityProcessDetails: FacilityProcessDetails[] = (facility.facilityProcessDetails || []).map((process: any) => ({
      FacilityProccessCategoryCode: process.facilityProcessCategoryCode || '',
      FacilityProcessUserSpecificTerm: process.facilityProcessCategoryUserSpecificTerm || '',
    }));
  console.log(facilityProcessDetails,"det")
    return {
      facilityInfo,
      facilityProcessDetails,
    };
  }